module.exports = __webpack_public_path__ + "static/media/cq_editor_lista_numerata b.ce572e9b.svg";